import React, { useState } from "react";
import PropTypes from "prop-types";
import { styled, useTheme } from "@mui/material/styles";
import { Typography, MobileStepper, Button } from "@mui/material";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

// Styled components
const Root = styled("div")(({ theme }) => ({
  maxWidth: "100%",
  flexGrow: 1,
}));

const Img = styled("img")({
  height: 255,
  display: "block",
  maxWidth: "100%",
  width: "100%",
  borderRadius: 13,
  objectFit: "cover",
  overflow: "hidden",
});

const SwipeableTextMobileStepper = ({ bannerData }) => {
 // console.log("BannerData",bannerData)
  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);

  const banners = bannerData || [];
  const maxSteps = banners.length;

  const handleNext = () => setActiveStep((prev) => prev + 1);
  const handleBack = () => setActiveStep((prev) => prev - 1);
  const handleStepChange = (step) => setActiveStep(step);

  if (!banners || banners.length === 0) return null;

  return (
    <Root>
      <AutoPlaySwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
      >
        {banners.map((step, index) => (
          <div key={step.label} style={{ overflow: "hidden", width: "100%",paddingTop:"20px" }}>
            {Math.abs(activeStep - index) <= 2 && (
              <Img 
              style={{height:"auto"}}
                src={`https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/${step.bannerUrl}`}
                alt={step.label}
              />
            )}
          </div>
        ))}
      </AutoPlaySwipeableViews>

      {/* Dots / MobileStepper */}
      <MobileStepper
        sx={{ background: "transparent" }}
        steps={Math.min(banners.length, 5)}
        position="static"
        activeStep={activeStep}
        nextButton={
          <Button
            size="small"
            sx={{ visibility: "hidden" }}
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
          >
            Next {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
          </Button>
        }
        backButton={
          <Button
            size="small"
            sx={{ visibility: "hidden" }}
            onClick={handleBack}
            disabled={activeStep === 0}
          >
            {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />} Back
          </Button>
        }
      />
    </Root>
  );
};

SwipeableTextMobileStepper.propTypes = {
  BannerData: PropTypes.shape({
    banners: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        bannerUrl: PropTypes.string,
      })
    ),
  }),
};

export default SwipeableTextMobileStepper;
